import React, { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { useFetchWrapper } from '../../_helpers/fetchWrapper.js';
import config from '../../config.js';
import PromotionConfirmDialog from './PromotionConfirmDialog.jsx';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/FollowerActions.css';

const FollowerActions = ({
  follower,
  bandId,
  onPromotionStart,
  onPromotionSuccess,
  onPromotionError,
  isPromoting,
}) => {
  const fetchWrapper = useFetchWrapper();
  const t = useT();
  const [showDialog, setShowDialog] = useState(false);
  const [promotionLoading, setPromotionLoading] = useState(false);
  const [error, setError] = useState('');

  const handleMakeModerator = async () => {
    setPromotionLoading(true);
    setError('');
    onPromotionStart();

    try {
      await fetchWrapper.post(`${config.apiBaseUrl}/bands/${bandId}/moderators`, {
        user_id: follower.user_id,
      });
      setShowDialog(false);
      setPromotionLoading(false);
      onPromotionSuccess();
    } catch (err) {
      setError(err.message || t('followers.actions.promoteError'));
      setPromotionLoading(false);
      onPromotionError();
    }
  };

  if (isPromoting) {
    return (
      <div className="faction__spinner" role="status">
        <FaSpinner className="faction__spin" aria-hidden="true" />
        <span className="faction__status-text">{t('followers.actions.promoting')}</span>
      </div>
    );
  }

  return (
    <div className="faction">
      {error && (
        <p className="faction__error" role="alert">{error}</p>
      )}
      <button
        className="faction__btn"
        onClick={() => setShowDialog(true)}
        disabled={promotionLoading}
      >
        {t('followers.actions.promoteToModerator')}
      </button>

      {showDialog && (
        <PromotionConfirmDialog
          isOpen={showDialog}
          onClose={() => setShowDialog(false)}
          onConfirm={handleMakeModerator}
          user={follower}
          promotionType="moderator"
          isLoading={promotionLoading}
        />
      )}
    </div>
  );
};

export default FollowerActions;
